import React, { useState, useEffect } from 'react'
import { validateProfile } from '../../validation/Authentication/Validation.js';
import { toast } from 'react-toastify';
import axios from 'axios';
import useGetUserData from '../../secureAPI/GetUserData';
import Navigations from '../../common/useNavigation';
import { useErrorContext } from '../../context/ErrorContext';
import { StartLoading, StopLoading } from '../../Utils/loadingUtils.js';
import axiosJWT from '../../secureAPI/axiosJWT.js';
import { showToast } from '../../Utils/toastUtils.js';

const MidProfile = (type) => {
    const { navigateDashboard } = Navigations();
    const { users,userPlan,Remainuser,subUser } = useGetUserData();
    const [isLoading, setisLoading] = useState(false);
    const [isDisabled, setisDisabled] = useState(false);
    const { setValidationError, clearAllErrors } = useErrorContext();
    const [isIndian, setisIndian] = useState(null);

    const [showEditUserinfoModal, setshowEditUserinfoModal] = useState(false);
    const [modalcondition, setModalCondition] = useState();
    const [uploadedFiles, setUploadedFiles] = useState([]);
    const [documents, setDocuments] = useState([]);

    const [formData, setFormdata] = useState([
        {
            fullName: '',
            contactNumber: '',
            emailAddress: '',
            address1: '',
            address2: '',
            countryId: 0,
            stateId: 0,
            cityId: 0,
            pincode: ''

        }
    ]);
    const [companyData, setCompanyData] = useState([
        {
            companyName: '',
            officeNumber: '',
            Initials: '',
            GSTNumber: '',
            GSTDoc: '',
            Website: '',
        }
    ]);


    const [countryData, setCountryData] = useState([]);
    const [selectedCountryId, setSelectedCountryId] = useState(0);

    const [stateData, setStateData] = useState([]);
    const [selectedStateId, setSelectedStateId] = useState(0);

    const [cityData, setCityData] = useState([]);
    const [selectedCityId, setSelectedCityId] = useState(0);

    const [EditedState, setEditedState] = useState();
    const [EditedCity, setEditedCity] = useState();

    const [dbState, setdbState] = useState();
    const [dbCity, setdbCity] = useState();

    const [selectedCountry, setSelectedCountry] = useState(null);
    const [selectedState, setSelectedState] = useState(null);

    const [selectedCity, setSelectedCity] = useState(null);

    const [error, setError] = useState({});
    const [personalEditId, setPersonalEditId] = useState("");
    const [companyEditId, setCompanyEditId] = useState("");
    const [documentEditId, setDocumentId] = useState("")

    useEffect(() => {
        //  console.log('called useeffectsss');
        if (Array.isArray(users) && users.length > 0) {
            // console.log('useEffect called, users:', users);
            logUserData();
        }
    }, [users]);
    const logUserData = () => {
        // console.log({ users: users });
        if (users?.length > 0) {
            const userTypes = users[0]['UserType'];
            const usertypeArray = typeof userTypes === 'string' ? userTypes.split(',').map(str => parseInt(str.trim())).filter(num => !isNaN(num)) : [];

            const hasOne = usertypeArray.includes(1);
            const hasTwo = usertypeArray.includes(2);
            if (type === 'seller' && users[0]['IsPersonalDetils'] === 1 && (hasOne && hasTwo)) { }
            else if (type === 'buyer' && users[0]['IsPersonalDetils'] === 1 && (hasOne)) { }
            else {
                navigateDashboard('buyer');
            }
        }
    };

    useEffect(() => {
        if (users?.length > 0) {


            const user = users[0];
            setFormdata(prev => ({
                ...prev,
                fullName: user?.FullName || '',
                contactNumber: user?.Mobile || '',
                emailAddress: user?.EmailAddress || '',
                address1: user?.Address1 || '',
                address2: user?.Address2 || '',
                pincode: user?.Pincode || '',
                cityId: user?.City?.id || null,
                cityName: user?.City?.name || '',
                stateId: user?.State?.id ? parseInt(user.State.id) : null,
                stateName: user?.State?.name || '',
                countryId: user?.Country?.id || null,
                countryName: user?.Country?.name || '' // Fixed from duplicate stateName
            }));

            setCompanyData(prev => ({
                companyName: user?.CompanyDetails?.Name || '',
                officeNumber: user?.CompanyDetails?.ContactNumber || '',
                Initials: user?.CompanyDetails?.Initials || '',
                GSTNumber: user?.CompanyDetails?.GSTNumber || 'NA',
                GSTDoc: user?.CompanyDetails?.GSTDoc || '',
                Website: user?.CompanyDetails?.Website || 'NA',
            }));

        } else {
            // Reset form if no user data
            setFormdata(prev => ({
                ...prev,
                fullName: '',
                contactNumber: '',
                emailAddress: '',
                address1: '',
                address2: '',
                pincode: '',
                cityId: null,
                cityName: '',
                stateId: null,
                stateName: '',
                countryId: null,
                countryName: ''
            }));
        }
    }, [users]);

    useEffect(() => {
        if (formData.stateId && stateData.length) {
            const state = stateData.find(s => s.value === parseInt(formData.stateId));
            // console.log('State Data:', stateData);
            // console.log('formData.stateId:', formData.stateId, typeof formData.stateId);
            // console.log('Comparison candidates:',
            //     stateData.map(s => ({ value: s.value, type: typeof s.value }))
            // );
            setSelectedState(state || null);
        }
    }, [formData.stateId, stateData]);

    useEffect(() => {
        if (formData.cityId && cityData.length) {
            const cities = cityData.find(s => s.value === formData.cityId);
            setSelectedCity(cities || null);
        }
    }, [formData.cityId, cityData]);


    const handleUserInfoModalClose = () => {
        setshowEditUserinfoModal(false);
    }
    const handleUserInfoModalShow = () => {
        // console.log(users)
        if (users && users.length > 0) {
            setshowEditUserinfoModal(true);
            if (users[0]['IsIndian'] === 0) {
                setisIndian(false);
                StopLoading(setisLoading);
                getCountries();
            }
            else {
                const userState = users[0]['State'] ? parseInt(users[0].State.id) : null;
                const userCity = users[0]['City'] ? parseInt(users[0].City.id) : null;
                setisIndian(true);
                StopLoading(setisLoading);
                // Get the state value from user data if it exists
                // console.log('userState' + userState);
                // Only set state if it exists
                if (userState) {
                    getStates(101, userState);
                    setFormdata(prev => ({ ...prev, stateId: userState }));
                    setSelectedCountryId(101);
                    // Only get cities if state exists
                    getCities(userState);
                    // Only set city if it exists
                    if (userCity) {
                        setFormdata(prev => ({ ...prev, cityId: userCity }));
                    }
                }
            }
        } else {
            // Handle the case when 'users' array is empty or undefined
            console.error("No users available");
        }

    }
    const handleGetCities = (id) => {
        // console.log(id);
        setSelectedStateId(id)
        getCities(id);
    }
    const handleSetCityId = (id) => {
        // console.log(id);
        setSelectedCityId(id)
    }
    const handleStateChange = (selectedOption) => {
        setSelectedState(selectedOption);
        // Update your form data
        setFormdata(prev => ({ ...prev, stateId: selectedOption?.value || null }));
        // Call your cities function if needed
        if (selectedOption) {
            handleGetCities(selectedOption.value);
        }
    }
    const handleCityChange = (selectedOption) => {
        setSelectedCity(selectedOption);
        // Update your form data
        setFormdata(prev => ({
            ...prev, cityId: selectedOption?.value || null
        }));
        // Call your cities function if needed
        if (selectedOption) {
            handleSetCityId(selectedOption.value);
        }
    }

    const handleGetState = (id) => {
        // alert(id);
        setSelectedCountryId(id)
        getStates(id);
    }

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormdata({ ...formData, [name]: value })
    }

    const GetCompanyProfileEdit = (rowID) => {
        handleUserInfoModalShow();
        setModalCondition(1);
        setPersonalEditId(rowID);
    }

    const handleCountryChange = (selectedOption) => {

        if (selectedOption.countrys === 1) {
            setSelectedCountry(selectedOption);
            setSelectedState(null);
            setSelectedCity(null);
        }
        if (selectedOption.countrys === 2) {
            setSelectedState(selectedOption);
            setSelectedCity(null);
        }
        if (selectedOption.countrys === 3) {
            setSelectedCity(selectedOption);
        }

    };


    const getCountries = async () => {
        StartLoading(setisLoading);
        try {
            await axiosJWT.post(`${process.env.REACT_APP_API_URL}/api/Getcountries`,).then((res) => {
                StopLoading(setisLoading);
                if (res.data.success === 1) {
                    const transformedData = res.data.data.map(country => ({
                        label: country.name, // Country name as label
                        value: country.id,   // Country ID as value
                    }));
                    // console.log({ transformedData: transformedData });
                    setCountryData(transformedData);
                }
                else {
                    showToast(res.data.message, 'error');
                }
            })
                .catch((err) => { });
        } catch (err) {
            StopLoading(setisLoading);
            showToast("Failed to find countries, please try again later ", 'error');
        }
    };
    const getStates = async (country_id) => {
        // console.log('country_id'+ country_id);
        StartLoading(setisLoading);
        try {
            await axiosJWT.post(`${process.env.REACT_APP_API_URL}/api/Getstates`, { countryid: country_id, }).then((res) => {
                StopLoading(setisLoading);
                if (res.data.success === 1) {
                    const transformedData = res.data.data.map(state => ({
                        label: state.name, // Country name as label
                        value: state.id,   // Country ID as value
                    }));
                    setStateData(transformedData);
                }
                else {
                    showToast(res.data.message, 'error');
                }
            })
                .catch((err) => {
                    StopLoading(setisLoading);
                    showToast("Failed to find states, please try again later ", 'error');
                });
        } catch (err) {
            StopLoading(setisLoading);
            showToast("Failed to find States, please try again later ", 'error');
        }
    };
    const getCities = async (stateid) => {
        // console.log(stateid);
        const stateID = stateid;
        StartLoading(setisLoading);
        try {
            await axiosJWT.post(`${process.env.REACT_APP_API_URL}/api/Getcities`, { stateid: stateID }).then((res) => {
                StopLoading(setisLoading);

                if (res.data.success === 1) {
                    const transformedData = res.data.data.map(city => ({
                        label: city.name,
                        value: city.id,
                    }));
                    // console.log({ transformedData: transformedData });
                    setCityData(transformedData);
                    // const defaultCountry = transformedData.find(Cities => Cities.value === dbCity);
                    // setEditedCity(defaultCountry);
                }
                else {
                    showToast(res.data.message, 'error');
                }
            })
                .catch((err) => {
                    StopLoading(setisLoading);
                    showToast("Failed to find cities, please try again later ", 'error');
                });
        } catch (err) {
            StopLoading(setisLoading);
            showToast("Failed to find cities, please try again later ", 'error');
        }
    };
    const handleEditSubmit = async () => {
        // setError(validateProfile(formData));
        StartLoading(setisLoading);

        // Destructure form data
        const {
            fullName: user_name,
            contactNumber: mobile_num,
            emailAddress: emails,
            address1: address_1,
            address2: address_2,
            pincode
        } = formData;

        // Get location IDs (ensure we're using the value property if using react-select)
        const country_id = selectedCountryId?.value || selectedCountryId;
        const state_id = selectedState?.value || selectedState;
        const city_id = selectedCity?.value || selectedCity;

        // Validate required fields
        const requiredFields = {
            'Full Name': user_name,
            'Mobile Number': mobile_num,
            'Email': emails,
            'Address Line 1': address_1,
            'Country': country_id,
            'State': state_id,
            'City': city_id,
            'Pincode': pincode
        };

        // Check for empty fields
        const missingFields = Object.entries(requiredFields)
            .filter(([_, value]) => !value)
            .map(([field]) => field);

        if (missingFields.length > 0) {
            showToast(`Missing required fields: ${missingFields.join(', ')}`, 'error');

            return;
        }

        // Validate email format
        if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(emails)) {

            showToast('Please enter a valid email address', 'error');
            return;
        }

        // Validate mobile number (assuming 10 digits for example)
        if (!/^\d{10}$/.test(mobile_num)) {

            showToast('Please enter a valid 10-digit mobile number', 'error');
            return;
        }
        if (!state_id) {
            showToast('Please Select State !!! ', 'error');
            return;
        }
        if (!city_id) {
            showToast('Please Select City !!! ', 'error');
            return;
        }

        try {
            // Submit form data
            const response = await axios.post(
                `${process.env.REACT_APP_API_URL}/api/EditPersonalDetails`,
                {
                    username: user_name,
                    mobilenum: mobile_num,
                    email: emails,
                    address1: address_1,
                    address2: address_2,
                    countryId: country_id,
                    stateId: state_id,
                    cityId: city_id,
                    pincode: pincode
                },
                { withCredentials: true }
            );
            StopLoading(setisLoading)
            window.location.reload();
            if (response.data.success) {

                const userData = response.data.userData;
                // console.log({ userData: userData });
                setFormdata(prev => ({
                    ...prev,
                    fullName: userData?.full_name || '',
                    contactNumber: userData?.mobile || '',
                    emailAddress: userData?.email || '',
                    address1: userData?.address1 || '',
                    address2: userData?.address2 || '',
                    pincode: userData?.pincode || '',
                    cityId: userData?.city_id || null,
                    cityName: userData?.city_name || '',
                    stateId: userData?.state_id ? parseInt(userData.state_id) : null,
                    stateName: userData?.state_name || '',
                    countryId: userData?.country_id || null,
                    countryName: userData?.country_name || '' // Fixed from duplicate stateName
                }));
                // setFormdata(prev => ({
                //     ...prev, // Spread all existing form data
                //     fullName: userData.FullName,
                //     contactNumber: userData.Mobile,
                //     emailAddress: userData.EmailAddress,
                //     address1: userData.Address1,
                //     address2: userData.Address2,
                //     pincode: userData.Pincode,
                //     cityId: userData.City?.id || null, // Optional chaining with fallback
                //     cityName: userData.City?.name || '',
                //     stateId: userData.State?.id ? parseInt(users[0].State.id) : null,
                //     stateName: userData.State?.name || '',
                //     countryId: userData.Country?.id || null,
                //     countryName: userData.Country?.name || '' // Fixed duplicate stateName
                // }));
                handleUserInfoModalClose();

                setSelectedCity("");
                setSelectedState("");
                setSelectedCountry("");
                showToast(response.data.message, 'success');
            } else {
                showToast(response.data.message, 'error');

            }
        } catch (error) {
            console.error('Submission error:', error);
            toast.error(
                error.response?.data?.message ||
                'An error occurred while updating details',
                { theme: "colored" }
            );
        }

    }


    const handleCompanyChange = (e) => {
        const { name, value } = e.target;
        setCompanyData(prev => ({ ...prev, [name]: value }));
    }

    const GetUserData = () => {
        handleUserInfoModalShow();
        setModalCondition(2);
        setCompanyEditId();
    }


    const handleCompanyDataEditSubmit = async () => {
        setError(validateProfile(formData));
        StartLoading(setisLoading);

        // Destructure form data
        const {
            companyName: companyName,
            officeNumber: officeNumber,
            Initials: Initials,
            GSTNumber: GSTNumber,
            GSTDoc: GSTDoc,
            Website: Website,
        } = companyData;


        // Validate required fields
        const requiredFields = {
            'Company Name': companyName,
            'Company Initials': Initials,
        };

        // Check for empty fields
        const missingFields = Object.entries(requiredFields)
            .filter(([_, value]) => !value)
            .map(([field]) => field);

        if (missingFields.length > 0) {
            showToast(`Missing required fields: ${missingFields.join(', ')}`, 'error');
            return;
        }



        try {
            // Submit form data
            const response = await axios.post(
                `${process.env.REACT_APP_API_URL}/api/EditCompanyDetails`, { companyName, officeNumber, Initials, GSTNumber, Website },
                { withCredentials: true }
            );
            StopLoading(setisLoading)
            if (response.data.success) {

                const userData = response.data.userData;
                // console.log({ userData: userData });
                setFormdata(prev => ({
                    ...prev,
                    fullName: userData?.full_name || '',
                    contactNumber: userData?.mobile || '',
                    emailAddress: userData?.email || '',
                    address1: userData?.address1 || '',
                    address2: userData?.address2 || '',
                    pincode: userData?.pincode || '',
                    cityId: userData?.city_id || null,
                    cityName: userData?.city_name || '',
                    stateId: userData?.state_id ? parseInt(userData.state_id) : null,
                    stateName: userData?.state_name || '',
                    countryId: userData?.country_id || null,
                    countryName: userData?.country_name || '' // Fixed from duplicate stateName
                }));
                // setFormdata(prev => ({
                //     ...prev, // Spread all existing form data
                //     fullName: userData.FullName,
                //     contactNumber: userData.Mobile,
                //     emailAddress: userData.EmailAddress,
                //     address1: userData.Address1,
                //     address2: userData.Address2,
                //     pincode: userData.Pincode,
                //     cityId: userData.City?.id || null, // Optional chaining with fallback
                //     cityName: userData.City?.name || '',
                //     stateId: userData.State?.id ? parseInt(users[0].State.id) : null,
                //     stateName: userData.State?.name || '',
                //     countryId: userData.Country?.id || null,
                //     countryName: userData.Country?.name || '' // Fixed duplicate stateName
                // }));
                handleUserInfoModalClose();
                showToast(response.data.message, 'success');
            } else {
                showToast(response.data.message, 'error');

            }
        } catch (error) {
            console.error('Submission error:', error);
            toast.error(
                error.response?.data?.message ||
                'An error occurred while updating details',
                { theme: "colored" }
            );
        }




    }

    const [selectedImage, setSelectedImage] = useState(null);
    const [imagePreview, setImagePreview] = useState(null);

    const handleFileChange = (event) => {
        const file = event.target.files[0];
        if (file) {
            setSelectedImage(file);
            setImagePreview(URL.createObjectURL(file));
        }
    };

    const GetDocumentEdit = (rowId) => {
        handleUserInfoModalShow();
        setModalCondition(3);
        setDocumentId(rowId);
    }

    const handleDocumentEdit = () => {
        const document_img = selectedImage;
    }

    const removeFile = (index) => {
        setUploadedFiles(prev => prev.filter((_, i) => i !== index));
        // You might also want to call an API to delete the file from the server
    };

    return {
        users,userPlan,Remainuser,subUser,
        formData, setFormdata, handleChange, GetCompanyProfileEdit, countryData, getStates, getCities, handleCountryChange, selectedCountry, selectedState, selectedCity, companyData, GetUserData, modalcondition, handleEditSubmit, error, handleCompanyChange, handleFileChange, selectedImage, imagePreview, GetDocumentEdit, showEditUserinfoModal, setshowEditUserinfoModal, handleUserInfoModalClose, handleUserInfoModalShow, handleGetState, stateData, handleGetCities, cityData, handleSetCityId, EditedState, EditedCity, handleStateChange, handleCityChange, handleCompanyDataEditSubmit, uploadedFiles, setUploadedFiles, removeFile, documents, setDocuments, isDisabled, setisDisabled, isLoading, setisLoading,
    }
}

export default MidProfile